import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';

// Pages
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Subaccounts from './pages/Subaccounts';
import CreateSubaccount from './pages/CreateSubaccount';
import EditSubaccount from './pages/EditSubaccount';
import Profile from './pages/Profile';
import Users from './pages/Users';

function App() {
  return (
    <AuthProvider>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <Routes>
        {/* Public Routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />

        {/* Protected Routes */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="subaccounts" element={<Subaccounts />} />
          <Route
            path="subaccounts/create"
            element={
              <ProtectedRoute allowedRoles={['owner', 'admin']}>
                <CreateSubaccount />
              </ProtectedRoute>
            }
          />
          <Route path="subaccounts/:id/edit" element={<EditSubaccount />} />
          <Route
            path="profile"
            element={
              <ProtectedRoute allowedRoles={['owner']}>
                <Profile />
              </ProtectedRoute>
            }
          />
          <Route
            path="users"
            element={
              <ProtectedRoute allowedRoles={['owner', 'admin']}>
                <Users />
              </ProtectedRoute>
            }
          />
        </Route>

        {/* Catch all */}
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </AuthProvider>
  );
}

export default App;
// rebuild 1782212885
